import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import  CertPaymentModel  from "../../models/certpayment";
import BSelectInput from "../../helpers/bselect-input";
import Barcode from 'react-barcode';
import { baseService } from '../../services';

const PaymentTypeList = [
  
    { label: "تعیین نشده", value: 0 },
    { label: "درگاه پیامکی پانو", value: 1 },
    { label: "درگاه اینترنتی پانو", value: 2 },
    { label: "دستگاه کارت خوان", value: 3 },
    { label: "پرداخت از طریق واریز وجه", value: 4 },
    { label: "پرداخت قبض", value: 5 }

  ];

  const PayTypeList = [
    { label: "پرداخت کامل", value: 0 },
    { label: "پرداخت با تخفیف", value: 3 }
   

  ];
  
  
class CertReqPaymentModal  extends Component {
    
    constructor() {
        super();
    
        this.state = {
          modalIsOpen: false,
          model:null,
          isPaymentSent:false
         
        };
    
        this.openModal = this.openModal.bind(this);
        this.updatePayTypeSelect=this.updatePayTypeSelect.bind(this);
        this.updatePaymentTypeSelect=this.updatePaymentTypeSelect.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submitPayment=this.submitPayment.bind(this);
        this.refreshModel= this.refreshModel.bind(this);
        this.postback= this.postback.bind(this);
        this.sendpayment=this.sendpayment.bind(this);
      }

      sendpayment()
      {
       this.setState({isPaymentSent:true});
        let model=this.getData();  
        var ws = new WebSocket('ws://localhost:8585/');
        ws.onopen = () =>{
          //send any msg from Client if needed
          var isSent=this.state.isPaymentSent;
          if(isSent == false)
          {
            ws.send('2200|' + model.BillNum +'|' +model.BillPayment);
          }
         
        }
        ws.onmessage = evt =>{
         console.log("pos data:" + evt.data);
         let _model=this.getData();  
         _model.RecieptNoValue +=evt.data;
         this.setState({model:_model});
         this.setState({isPaymentSent:false});
        
         this.props.submitPaymentHandler(_model);
         this.closeModal();
        }
        this.setState({isPaymentSent:false});
      }
      
      postback() {
        this.refreshModel ();
        let model=this.getData();  
        baseService.post(model,'certificationpayment','GetBillInfo/'+model.Id,null)
        .then(
            objs => { 
              console.log('dssddsdsdssd',objs)
              this.setState({

                model:objs
            
              });
              this.refreshModel()
            },
            error => {
              console.log('eeee')
            }
        );

      }

      openModal(model=null) {
        this.setState({modalIsOpen: true,model:model});
      }
    
     
      closeModal() {
        this.setState({modalIsOpen: false});
        
      }

      submitPayment(){
        let model=this.getData();  
        this.props.submitPaymentHandler(model);
        this.closeModal();
      }

      updatePayment(){
        let model=this.getData();  
        this.props.submitPaymentHandler(model);
        this.closeModal();
      }

      refreshModel () {
        let __model = new CertPaymentModel(this.refs); 
        console.log(__model.PaymentType)
 
        try{

          if (typeof __model.PaymentType.value === 'undefined') {

            
            __model.PaymentType=__model && __model.PaymentType;
            console.log('un',__model.PaymentType)

          }
          


        }catch(e)
        {

        }

        try{
          if (typeof __model.PaymentType.value !== 'undefined') {
            __model.PaymentType=__model && __model.PaymentType.value;
            console.log('val',__model.PaymentType.value)
  
          }
        

        }catch(e)
        {

        }

        console.log('pay',__model);

        this.setState({

            model:__model

        });

           
      }

    
      getData() {
          let {model} =this.state;
         
          return model;
      }
      updatePaymentTypeSelect(item) {
          
          let __model = new CertPaymentModel(this.refs);  
         

          __model.PaymentType=item && item.value;

         
          this.setState({

              model:__model

          });
          console.log(__model.PaymentType)
          if(__model.PaymentType ==5)
          {
            this.updatePayment();
          }
        
      }
      updatePayTypeSelect(item) {
          
        let __model = new CertPaymentModel(this.refs); 
        
  
        try{
          if (typeof __model.PaymentType.value === 'undefined') {
            __model.PaymentType=__model && __model.PaymentType;
          }
        }catch(e)
        {

        }

        try{

          __model.PaymentType=__model && __model.PaymentType.value;
         

        }catch(e)
        {

        }


        __model.PayType=item && item.value;
        

        this.setState({

            model:__model

        });
      
    }
    
      render() {
        const {model} = this.state;
       
        return (
           <Modal style={{opacity:1}} show={this.state.modalIsOpen} onHide={this.closeModal} centered size="lg" aria-labelledby="contained-modal-title-vcenter" >
 
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    پرداخت
                </Modal.Title>
            </Modal.Header>    
            <Modal.Body>
                <input type="hidden" value={model && model.Id} ref="Id"></input>
                <input type="hidden" value={model && model.CertificationTariffId} ref="CertificationTariffId"></input>
                <input type="hidden" value={model && model.CertificationRequestId} ref="CertificationRequestId"></input>
                <input type="hidden" value={model && model.CertificationTypeId} ref="CertificationTypeId"></input>
                <input type="hidden" value={model && model.RecieptNoValue} ref="RecieptNoValue"></input>
              
                <div className="form-horizontal">
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">عنوان</label>
                        <div class="col-sm-9">
                            <input  className="form-control"  value={model && model.CertificationType && model.CertificationType.Title }  type="text" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">تعرفه</label>
                        <div class="col-sm-9">
                            <input  className="form-control"  value={model && model.CertificationType && model.CertificationTariff.Title }  type="text" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">مبلغ تعرفه</label>
                        <div class="col-sm-9">
                            <input  className="form-control"  value={model && model.CertificationTariff && model.CertificationTariff.Price }  type="text" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">روش پرداخت</label>
                        <div class="col-sm-9">
                            <BSelectInput 
                                ref="PaymentType"                                   
                                onChange={this.refreshModel}
                                value ={model && PaymentTypeList.find(p=>p.value=== model.PaymentType) }
                                options={PaymentTypeList}
                                onChangeHandler={this.updatePaymentTypeSelect}
                                clearable={false}
                                name="PaymentType"
                                normal={true}
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">نوع پرداخت</label>
                        <div class="col-sm-9">
                            <BSelectInput 
                                                                  
                                onChange={this.refreshModel}
                                value ={model && PayTypeList.find(p=>p.value=== model.PayType) }
                                options={PayTypeList}
                                onChangeHandler={this.updatePayTypeSelect}
                                clearable={false}
                                name="PayType"
                                normal={true}
                            />
                        </div>
                        <input type="hidden" name="PayType" ref="PayType" value={model && model.PayType}></input>
                    </div>
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">مبلغ قابل پرداخت</label>
                        <div class="col-sm-9">
                            <input className="form-control" readOnly={model && model.PayType!=3} onChange={this.refreshModel} value={model && model.PaymentValue  } ref="PaymentValue" name="PaymentValue" type="text" />
                        </div>
                    </div>
                  {model && model.PaymentType==1  &&
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">شماره تلفن همراه</label>
                        <div class="col-sm-9">
                            <input className="form-control" onChange={this.refreshModel} value={model.CellNumber } ref="CellNumber" name="CellNumber" type="text" />
                        </div>
                    </div>
                  }
                  {model && model.PaymentType==2  &&
                    <div class="form-group">
                        <label class="control-label col-sm-3" for="email">شماره تلفن همراه</label>
                        <div class="col-sm-9">
                            <input className="form-control" onChange={this.refreshModel} value={model.CellNumber } ref="CellNumber" name="CellNumber" type="text" />
                        </div>
                    </div>
                  }
                  { model && model.PaymentType==4 &&
                    <div>
                      <div class="form-group">
                          <label class="control-label col-sm-3" for="email">نام شعبه</label>
                          <div class="col-sm-9">
                              <input className="form-control" onChange={this.refreshModel} value={'بهشت زهرا'} ref="BankBranchName" name="BankBranchName" type="text" />
                          </div>
                      </div>
                      <div class="form-group">
                          <label class="control-label col-sm-3" for="email">کد شعبه</label>
                          <div class="col-sm-9">
                              <input className="form-control" onChange={this.refreshModel} value={'296' } ref="BankBranchCode" name="BankBranchCode" type="text" />
                          </div>
                      </div>
                      <div class="form-group">
                          <label class="control-label col-sm-3" for="email">شماره رسید</label>
                          <div class="col-sm-9">
                              <input className="form-control" onChange={this.refreshModel} value={model.BankRecieptCode } ref="BankRecieptCode" name="BankRecieptCode" type="text" />
                          </div>
                      </div>
                    </div>
                  }
                  {model && model.PaymentType==5  &&
<div>
                        <div class="form-group">
                        <label class="control-label col-sm-3" for="email">شماره تلفن همراه</label>
                        <div class="col-sm-9">
                            <input className="form-control" onChange={this.refreshModel} value={model.CellNumber } ref="CellNumber" name="CellNumber" type="text" />
                        </div>
                        </div>
                        <div class="form-group">
                        <label class="control-label col-sm-3" for="email">شناسه قبض</label>
                        <div class="col-sm-9">
                            <input className="form-control" onChange={this.refreshModel} value={model.BillNum } ref="BillNum" name="BillNum" type="text" />
                        </div>
                        </div>
                        <div class="form-group">
                        <label class="control-label col-sm-3" for="email">شناسه پرداخت</label>
                        <div class="col-sm-9">
                            <input className="form-control" onChange={this.refreshModel} value={model.BillPayment } ref="BillPayment" name="BillPayment" type="text" />
                        </div>
                        </div>
                        <div class="form-group">
                        <label class="control-label col-sm-3" for="email">بارکد</label>
                        <div class="col-sm-9">
                        
                        <Barcode value={model.BillNum + model.BillPayment} options={{height:50}} />
                        </div>

                        
                        </div>
                        <div class="form-group">
                        <label class="control-label col-sm-3" for="email"></label>
                        <div class="col-sm-9">
                        
                        <Button variant="primary" onClick={this.postback}>
                           دریافت قبض
                        </Button>

                        <Button variant="success" onClick={this.sendpayment}>
                          ارسال قبض
                        </Button>
                        </div>
                        
                        
                        </div>
                        
                        </div>

                  }

                </div>
                
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>
                انصراف
              </Button>
              <Button variant="primary" onClick={this.submitPayment}>
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }
}

 
export default CertReqPaymentModal;